import React, { ReactElement } from 'react';

import { classNames } from 'utils/css';

import { THeadingProps } from './Heading.types';
import styles from './Heading.module.scss';
import { HEADING_COLOR, HEADING_TAG } from './Heading.constants';

function Heading({
  as: Element = HEADING_TAG.h2,
  color = HEADING_COLOR.primary,
  align,
  children,
}: THeadingProps): ReactElement {
  const className = classNames(
    styles.heading,
    color && styles[color],
    align && styles[align]
  );

  return (
    <Element className={className} data-testid="Heading">
      {children}
    </Element>
  );
}

export { Heading };
